<template>
  <div>
    <!-- Title -->
    <div class="content">
      <h2 class="subtitle">Pregled svih događaja</h2>
    </div>

    <!-- Tabs -->
    <div class="tabs is-centered is-medium">
      <ul>
        <li :class="{ 'is-active': this.tabSelector === 0 }">
          <a @click="tabClicked(0)">Danas</a>
        </li>
        <li v-bind:class="{ 'is-active': this.tabSelector === 1 }">
          <a @click="tabClicked(1)">Juče</a>
        </li>
        <li :class="{ 'is-active': this.tabSelector === 2 }">
          <a @click="tabClicked(2)">Proizvoljan period</a>
        </li>
      </ul>
    </div>

    <!-- Time Span -->
    <div class="content" v-show="this.tabSelector === 2">
      <date-picker v-model="time3" @input="timeSpanChosen" range></date-picker>
    </div>

    <!-- Table -->
    <div class="base-demo">
      <vue-table-dynamic
        :params="params"
        @cell-click="tableCellClicked"
      ></vue-table-dynamic>
    </div>

    <!-- spinner -->
    <div class="columns is-mobile" v-show="isLoading">
      <div class="column is-1 is-offset-half">
        <div class="container">
          <div class="has-text-centered">
            <!-- <p>loading...</p> -->
            <p>loading...</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from "../../services/user.service";
import ReportService from "../../services/report.service";
import VueTableDynamic from "vue-table-dynamic-sum";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

// import { BulmaAccordion, BulmaAccordionItem } from "vue-bulma-accordion";
import {
  getEventFromAccessLog,
  getDeviceFromAccessLog,
  getAccessTypeFromAccessLog,
} from "../../_helpers/arrangers";

export default {
  name: "Demo",
  components: {
    VueTableDynamic,
    DatePicker,
    // BulmaAccordion,
    // BulmaAccordionItem,
  },
  data() {
    return {
      tabSelector: 0,
      filterSelector: 0,
      departments: [],
      employees: [],
      selectedDepartment: null,
      selectedEmployee: null,
      startDate: new Date(),
      endDate: new Date(),
      time3: null,
      isLoading: false,
      params: {
        data: [
          [
            "Index",
            "Vrijeme",
            "Ime i prezime",
            "Sektor",
            "Vrsta prolaza",
            "uređaj",
            "Radnja",
          ],
        ],
        header: "row",
        enableSearch: true,
        border: true,
        stripe: true,
        pagination: true,
        pageSize: 100,
        columnWidth: [
          { column: 0, width: "7%" },
          { column: 1, width: "15%" },
          { column: 4, width: "25%" },
          { column: 5, width: "7%" },
          { column: 6, width: "25%" },
        ],
        sumIncludeInSearch: true,
        sumColumns: [{ column: 0, type: "increment" }],
      },
    };
  },
  mounted() {
    this.tabClicked(0);
    this.getDepartments();
  },
  activated() {},
  methods: {
    timeSpanChosen(span) {
      console.log(span);
      if (span[0] == null || span[1] == null) {
        return;
      }
      console.log("da");
      this.startDate = span[0];
      this.endDate = span[1];
      this.getData();
    },
    employeeSelected(emp) {
      console.log(emp.id);
    },
    departmentSelected(dep) {
      console.log(dep.id);
    },
    getDepartments() {
      this.isLoading = true;
      UserService.getDepartments().then((response) => {
        // reset ui
        console.log("Departments:");
        console.log(response.data);
        this.arrangeSectors(response.data);
        this.arrangeEmployees(response.data);
        console.log("Employees:");
        console.log(this.employees);
      });
    },
    tabClicked(value) {
      this.tabSelector = value;
      if (value === 0) {
        let yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
        let today = new Date();
        yesterday.setHours(24, 0, 0, 0);
        today.setHours(24, 0, 0, 0);
        this.startDate = yesterday;
        this.endDate = today;
        this.getData();
      } else if (value === 1) {
        let dayBeforeYesterday = new Date(
          new Date().setDate(new Date().getDate() - 2)
        );
        let yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
        this.startDate = dayBeforeYesterday;
        yesterday.setHours(24, 0, 0, 0);
        dayBeforeYesterday.setHours(24, 0, 0, 0);
        this.endDate = yesterday;
        this.getData();
      } else if (value === 2) {
        this.startDate = null;
        this.endDate = null;
      }
    },
    arrangeSectors(data) {
      data.forEach((element) => {
        this.departments.push({
          name: element.name,
          id: element.departmentId,
        });
      });
    },
    arrangeEmployees(data) {
      data.forEach((element) => {
        element.employee.forEach((emp) => {
          this.employees.push({
            name: emp.firstName + " " + emp.lastName,
            id: emp.employeeId,
          });
        });
      });
    },
    proba(date) {
      console.log(date);
    },
    tableCellClicked(row, column) {
      console.log(row);
      console.log(column);
      if (column === 4 && this.params.data[row][column].startsWith("📲")) {
        alert(this.params.data[row][column]);
        let url =
          "https://www.google.com/maps/place/" +
          this.params.data[row][column].split("📲 ")[1];
        window.open(url);
      }
    },
    resetUi() {
      this.params.data = [
        [
          "Index",
          "Vrijeme",
          "Ime i prezime",
          "Sektor",
          "Vrsta prolaza",
          "Uređaj",
          "Radnja",
        ],
      ];
    },
    getData() {
      this.isLoading = true;
      ReportService.GetRawAccessDataByTimeRange(
        this.startDate,
        this.endDate
      ).then((response) => {
        let ndx = 1;
        console.log("Raw access data:");
        console.log(response);
        this.isLoading = false;

        // reset ui
        this.resetUi();

        // populate table
        response.data.forEach((element) => {
          if (element.lastName === "Cimbaljević") {
            console.log(element);
          }
          // if this employee is in employee list push it to table
          if (
            this.employees.find((emp) => emp.id === element.employeeId) !==
            undefined
          ) {
            this.params.data.push([
              ndx++,
              new Date(element.accessTime).toLocaleString("sr-latn-cs"), //.toLocaleDateString("sr-latn-cs"),
              element.firstName + " " + element.lastName,
              element.department,
              getAccessTypeFromAccessLog(element, ""),
              getDeviceFromAccessLog(element),
              getEventFromAccessLog(
                element,
                this.$store.state.general.checkpointNames
              ),
            ]);
          }
        });
        // this.params.data.push;
      });
    },
  },
};
</script>
